// import router from "@/router";
import { appService } from "../../service/appService";
export const namespaced = true;

const getDefaultState = () => {
  return {
    overlay: false,
    allData:null,
    paymentHistoryScope:null,
    questionHistory:[],
    consultantQuestionHistory:[],
    consultantHistory:[],
    totalDocs:null,

  };
};

// initial state
export const state = getDefaultState();

export const getters = {
  getOverlay(state) {
    return state.overlay;
  },

  getAllData(state) {
    return state.allData;
  },
  getPaymentHistoryScope(state) {
    return state.paymentHistoryScope;
  },
  getQuestionHistory(state) {
    return state.questionHistory;
  },
  getConsultantHistory(state) {
    return state.consultantHistory;
  },
  getConsultantQuestionHistory(state) {
    return state.consultantQuestionHistory;
  },
};
export const mutations = {

  SET_OVERLAY(state, payload) {
    state.overlay = payload;
  },
  SET_ALL_DATA(state, payload) {
    state.allData = payload;
  },
    SET_PAYMENT_HISTORY_SCOPE(state, payload) {
    state.paymentHistoryScope = payload;
  },
  SET_QUESTION_HISTORY(state, payload) {
    state.questionHistory = payload;
  },
  SET_CONSULTANT_HISTORY(state, payload) {
    state.consultantHistory = payload;
  },
  SET_CONSULTANT_QUESTION_HISTORY(state, payload) {
    state.consultantQuestionHistory = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  }
};

export const actions = {
  setOverlay({ commit, state }, payload) {
    //console.log('overlay',payload)
    commit("SET_OVERLAY", payload);
  },
   async paymentHistoryScope({ commit }, payload) {
    const { data } = await appService().paymentHistoryScope(payload);
    // console.log("data-->",data.data)
    await commit("SET_PAYMENT_HISTORY_SCOPE", []);
     await commit("SET_PAYMENT_HISTORY_SCOPE", data.data);

    // commit('SET_DRAFT_LIST', data.data)
  },
  async questionHistory({ commit }, payload) {
    const { data } = await appService().questionHistory(payload);
    await commit("SET_QUESTION_HISTORY", []);
    await commit("SET_QUESTION_HISTORY", data.data);
  },
  async consultantHistory({ commit }, payload) {
    const { data } = await appService().consultantHistory(payload);
    await commit("SET_CONSULTANT_HISTORY", []);
    await commit("SET_CONSULTANT_HISTORY", data.data.docs);
    return data.data;
  },
  async consultantQuestionHistory({ commit }, payload) {
    const { data } = await appService().consultantQuestionHistory(payload);
    await commit("SET_CONSULTANT_QUESTION_HISTORY", []);
    await commit("SET_CONSULTANT_QUESTION_HISTORY", data.data.docs);
    return data.data;
  },

  resetState({ commit }) {
    commit("RESET_STATE");
  },
  logout() {
    $oidc.user = null;
    sessionStorage.clear();
    localStorage.clear();
    // router.push({ name: "Login" });
  }
};
